<template>
  <div class="product-list">
    <!--添加产品-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加等级</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <el-table-column prop="subscript" align="center" label="等级logo" width="150">
            <template slot-scope="scope">
              <img :src="scope.row.subscript" alt="" width="50" height="50" />
            </template>
          </el-table-column>
          <el-table-column prop="levelName" align="center" label="等级名称">
          </el-table-column>
          <el-table-column prop="level" align="center" label="等级">
          </el-table-column>
          <el-table-column prop="stopDay" align="center" label="入驻天数"></el-table-column>
          <el-table-column prop="followNum" align="center" label="关注人员数量"></el-table-column>
          <el-table-column prop="chargeback" align="center" label="退单率"></el-table-column>
          <el-table-column prop="allMoney" align="center" label="上周期完成金额"></el-table-column>
          <el-table-column prop="proportion" align="center" label="抽成比例率"></el-table-column>
          <el-table-column prop="inviteUserNum" align="center" label="邀请客户数量"></el-table-column>
          <el-table-column prop="inviteWaiterNum" align="center" label="邀请技师数量"></el-table-column>
          <el-table-column prop="showSort" align="center" label="排序"></el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="160">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="primary" size="small">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="danger" size="small" v-if="scope.row.level_id!=1">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import Technician from "@/api/technician.js";
// import Add from './Add.vue'
export default {
  components: {
    // Add
  },
  data() {
    return {
      tableData: [],
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    /*打开添加*/
    addClick() {
      this.$router.push("/technician/grade/add");
    },
    getData() {
      let self = this;
      let page = self.curPage;
      let pageSize = self.pageSize;
      Technician.technicianlevel(
        {
          page,
          pageSize
        },
        true
      )
        .then(data => {
          console.log(data,'所以数据')
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          // self.loading = false;
        });
    },
    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: "/technician/grade/edit",
        query: {
          levelId: row.levelId,
          scene: "edit"
        }
      });
    },
    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm("删除后将移动到回收站，确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          Technician.techniciandelete({
            level_id: row.levelId
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/grade/index.vue